export default {

  setCssVar(name, value) {
    const root = document.documentElement;
    root.style.setProperty(`--${name}`, value);
  },

  getCssVar(name) {
    const root = document.documentElement;
    return getComputedStyle(root).getPropertyValue(`--${name}`);
  }

};